const Transport = require('winston-transport')
const net = require('net')
const os = require('os')

const { EASEL_RELEASE } = process.env

// Inherit from `winston-transport` so you can take advantage
// of the base functionality and `.exceptions.handle()`.
//
class KibanaTransport extends Transport {
  constructor(options) {
    const defaults = {
      applicationName: process.title,
      pid: process.pid,
      silent: false,
      maxConnectRetries: 4,
      timeoutConnectRetries: 100,
      label: process.title,
      trailingLineFeed: false,
      trailingLineFeedChar: os.EOL,
      level: 'info',
    }

    options = options || {}
    options.applicationName = options.applicationName || options.appName || process.title
    options = { ...defaults, ...options }

    super(options)

    // Consume any custom options here
    const { host, port } = options
    this.config = { host, port }
    this.hostName = require('os').hostname()
    this.silent = options.silent
    // Assign all options to local properties
    Object.keys(options).forEach((key) => {
      this[key] = options[key]
    })

    this.name = 'logstashTransport'
    this.logQueue = []
    this.connectionState = 'NOT CONNECTED'
    this.socket = null
    this.retries = -1

    this.connect()
  }

  connect() {
    if (this.connectionState !== 'CONNECTED') {
      const { host, port } = this.config
      if (!host) {
        // Escape Early if Kibana Host is not SPECIFIED
        return
      }

      this.socket = new net.Socket()
      this.socket.connect({ host, port }, () => {
        this.socket.setKeepAlive(true, 60 * 1000)
        this.connectionState = 'CONNECTED'
        this.announce()
      })

      this.socket.on('error', () => {
        this.connectionState = 'NOT CONNECTED'

        if (this.socket && typeof this.socket !== 'undefined') {
          this.socket.destroy()
        }
        this.socket = null

        this.emit('close')
      })

      this.socket.on('timeout', () => {
        if (this.socket.readyState !== 'open') {
          this.socket.destroy()
        }
      })

      this.socket.on('connect', () => {
        this.connectionState = 'CONNECTED'
        this.retries = 0
        this.flush()
      })

      this.socket.on('close', () => {
        this.connectionState = 'NOT CONNECTED'
        setTimeout(() => this.connect(), 100)
      })
    } else {
      this.flush()
    }
  }

  deliver(message, callback) {
    if (this.trailingLineFeed) {
      message = message.replace(/\s+$/, '') + this.trailingLineFeedChar
    }
    callback = callback || (() => {})
    this.socket.write(message, null, callback)
  }

  log(info, callback) {
    if (this.silent) {
      callback(null, true)
      return
    }

    if (info.message) {
      // Perform the writing to the remote service
      const { hostName } = this
      // Log Info we want to FORMAT/PARSE
      const { appEnv, nodeEnv, timestamp, type, level, message, ...rest } = info
      const date = new Date()
      let data = {
        '@timestamp': timestamp || date,
        '@version': 1,
        env: {
          app: appEnv,
          node: nodeEnv,
          release: EASEL_RELEASE || 'unknown',
        },
        host: hostName,
        index: 'tcp-easel',
        level,
        message,
        type,
        ...rest,
      }

      data = JSON.stringify(data)

      this.logQueue.push({
        message: data,
        callback: () => {
          this.emit('logged', info)
          callback()
        },
      })

      // Try to connect
      // And flush out the messages
      this.connect()
    }
  }

  close() {
    if (this.connectionState === 'CONNECTED' && this.socket) {
      this.connectionState = 'TERMINATING'
      this.socket.end()
      this.socket.destroy()
      this.socket = null
      this.connectionState = 'NOT CONNECTED'
    }
  }

  flush() {
    while (this.logQueue.length > 0) {
      const elem = this.logQueue.shift()
      this.deliver(elem.message, elem.callback)
    }
  }

  announce() {
    this.flush()
    if (this.connectionState === 'TERMINATING') {
      this.close()
    } else {
      this.connectionState = 'CONNECTED'
    }
  }

  getQueueLength() {
    return this.logQueue.length
  }
}

module.exports = KibanaTransport
